import React from "react";

import AsyncSelect from "./AsyncSelect";

export default function AsyncWithSearch(props) {
  return <AsyncSelect enableSearch {...props} />;
}
